import React, { useMemo } from 'react'
import CellWithAvatar from '@groovehq/internal-design-system/lib/components/Table/CellWithAvatar/CellWithAvatar'
import { capitalize } from 'util/strings'

import UsersDropdown from './UsersDropdown'

const adminDropdownList = [
  {
    key: 'resetPassword',
    title: 'Reset password',
  },
  {
    key: 'advanced',
    title: 'Advanced',
  },
]

const adminDropdownAsAdmin = [
  {
    key: 'resetPassword',
    title: 'Reset password',
  },
  {
    key: 'beAgent',
    title: 'Remove admin access',
  },
  {
    key: 'advanced',
    title: 'Advanced',
  },
]

const adminDropdownAsOwnerList = [
  {
    key: 'resetPassword',
    title: 'Reset password',
  },
  {
    key: 'beAgent',
    title: 'Remove admin access',
  },
  {
    key: 'beOwner',
    title: 'Change to owner',
  },
  {
    key: 'advanced',
    title: 'Advanced',
  },
]

const agentDropdownList = [
  {
    key: 'resetPassword',
    title: 'Reset password',
  },
  {
    key: 'advanced',
    title: 'Advanced',
  },
]

const agentDropdownAsAdminList = [
  {
    key: 'resetPassword',
    title: 'Reset password',
  },
  {
    key: 'beAdmin',
    title: 'Change to admin',
  },
  {
    key: 'advanced',
    title: 'Advanced',
  },
]

const agentDropdownAsOwnerList = [
  {
    key: 'resetPassword',
    title: 'Reset password',
  },
  {
    key: 'beAdmin',
    title: 'Change to admin',
  },
  {
    key: 'beOwner',
    title: 'Change to owner',
  },
  {
    key: 'advanced',
    title: 'Advanced',
  },
]

const ownerDropdownList = [
  {
    key: 'resetPassword',
    title: 'Reset password',
  },
  {
    key: 'advanced',
    title: 'Advanced',
  },
]

const inviteeDropdownList = [
  {
    key: 'resendInvitation',
    title: 'Resend invitation email',
  },
  {
    key: 'revokeInvitation',
    title: 'Revoke invitation',
  },
]

const archivedDropdownList = [
  {
    key: 'unarchiveUser',
    title: `Unarchive ${app.t('agent')}`,
  },
]

const useColumns = ({ scope, currentUser }) => {
  const columns = useMemo(
    () => {
      const currentUserIsOwner = currentUser.role === 'owner'
      const currentUserIsAdmin = currentUser.role === 'admin'
      const formatName = ({ row: { original } }) => {
        const trimmedName = original.name.trim()
        const data = {
          email: trimmedName ? original.email : '',
          value: trimmedName || original.email,
          avatar: original.avatar_url,
          avatarSize: 'xl',
          userName: original.username,
        }
        return <CellWithAvatar data={data} />
      }

      const createDropdown = ({ row, onEdit, deleteData }) => {
        const onSelect = value => {
          onEdit({ id: row.id, type: value })
        }
        const onDelete = () => {
          deleteData(row.id)
        }
        const { original } = row
        if (scope === 'invited') {
          return (
            <UsersDropdown
              dropdownList={inviteeDropdownList}
              onSelect={onSelect}
            />
          )
        }
        if (scope === 'archived') {
          return (
            <UsersDropdown
              dropdownList={archivedDropdownList}
              onSelect={onSelect}
            />
          )
        }
        if (original.role === 'owner') {
          return (
            <UsersDropdown
              dropdownList={ownerDropdownList}
              onSelect={onSelect}
            />
          )
        }
        const isAdmin = original.role === 'admin'
        const isAgent = original.role === 'agent'
        let dropdownList
        if (currentUserIsOwner) {
          dropdownList = isAdmin
            ? adminDropdownAsOwnerList
            : agentDropdownAsOwnerList
        } else if (
          currentUserIsAdmin &&
          isAdmin &&
          original.id !== currentUser.id
        ) {
          dropdownList = adminDropdownAsAdmin
        } else if (
          currentUserIsAdmin &&
          isAgent &&
          original.id !== currentUser.id
        ) {
          dropdownList = agentDropdownAsAdminList
        } else {
          dropdownList = isAdmin ? adminDropdownList : agentDropdownList
        }
        return (
          <UsersDropdown
            dropdownList={dropdownList}
            footerName={
              currentUser.id === row.id ? null : `Archive ${app.t('agent')}`
            }
            onClickFooterBtn={currentUser.id === row.id ? null : onDelete}
            onSelect={onSelect}
          />
        )
      }

      const formatRole = ({ value }) => {
        return value ? capitalize(value) : null
      }

      const formatAuth = ({ value }) => {
        if (value === 'confirmed') return '2FA Enabled'
        if (value === 'enabled') return '2FA Enabled (unconfirmed)'
        if (value === 'disabled') return '2FA Disabled'
        return 'Unknown'
      }

      return [
        {
          Header: app.t('agents'),
          accessor: 'name',
          width: '75%',
          manualSortBy: true,
          Cell: formatName,
        },
        {
          Header: 'ROLE',
          accessor: 'role',
          Cell: formatRole,
          width: '10%',
          manualSortBy: true,
        },
        {
          Header: 'AUTHENTICATION',
          accessor: 'status2fa',
          Cell: formatAuth,
          width: '10%',
          disableSortBy: true,
        },
        {
          Header: '',
          accessor: 'id',
          Cell: createDropdown,
          disableSortBy: true,
          width: '5%',
        },
      ]
    },
    [scope, currentUser.id, currentUser.role]
  )

  return columns
}

export default useColumns
